import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-270">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-slate-200 shadow-[0_-10px_20px_rgba(0,0,0,0.05)] z-40 md:hidden" data-id="element-271">
          <button onClick={() => document.getElementById('final-cta')?.scrollIntoView({
        behavior: 'smooth'
      })} className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-6 rounded-full transition-colors shadow-md text-lg flex justify-between items-center" data-id="element-272">
            <span data-id="element-273">Get Instant Access</span>
            <span data-id="element-274">$17</span>
          </button>
        </motion.div>}
    </AnimatePresence>;
}